export var BusinessFeeAction;
(function (BusinessFeeAction) {
    /**
     * We add the fee to the charge amount before we charge the source.
     * @example
     * 1. User wants to deposit 100 USD and the fee is 1 USD. We charge the user card 101 USD
     * and deposit 100 USD to wallet.
     * 2. User wants to withdraw 100 NGN and the fee is 1 NGN. We charge the user wallet 101 NGN
     * and send 100 NGN to bank account
     */
    BusinessFeeAction["AddToSource"] = "ADD_TO_SOURCE";
    /**
     * We remove the fee from the amount we will send to the destination.
     * @example
     * 1. User wants to deposit 100 USD and the fee is 1 USD. We charge the user card 100 USD
     * and deposit 99 USD to wallet.
     * 2. User wants to withdraw 100 NGN and the fee is 1 NGN. We charge the user wallet 100 NGN
     * and send 99 NGN to bank account.
     */
    BusinessFeeAction["RemoveFromDestination"] = "REMOVE_FROM_DESTINATION";
})(BusinessFeeAction || (BusinessFeeAction = {}));
export var BusinessFeeField;
(function (BusinessFeeField) {
    BusinessFeeField["FromCurrency"] = "FROM_CURRENCY";
    BusinessFeeField["ToCurrency"] = "TO_CURRENCY";
    BusinessFeeField["FromCountry"] = "FROM_COUNTRY";
    BusinessFeeField["ToCountry"] = "TO_COUNTRY";
    BusinessFeeField["UserId"] = "USERID";
    BusinessFeeField["BusinessId"] = "BUSINESSID";
    BusinessFeeField["FromAmount"] = "FROM_AMOUNT";
    BusinessFeeField["ToAmount"] = "TO_AMOUNT";
    BusinessFeeField["FromChannel"] = "FROM_CHANNEL";
    BusinessFeeField["ToChannel"] = "TO_CHANNEL";
    BusinessFeeField["FromProcessor"] = "FROM_PROCESSOR";
    BusinessFeeField["ToProcessor"] = "TO_PROCESSOR";
    BusinessFeeField["TransactionType"] = "TRANSACTION_TYPE";
    BusinessFeeField["TransactionDate"] = "TRANSACTION_DATE";
    BusinessFeeField["WalletTag"] = "WALLET_TAG";
})(BusinessFeeField || (BusinessFeeField = {}));
export var BusinessFeeComparator;
(function (BusinessFeeComparator) {
    BusinessFeeComparator["Equals"] = "EQUALS";
    BusinessFeeComparator["LessThan"] = "LESS_THAN";
    BusinessFeeComparator["GreaterThan"] = "GREATER_THAN";
    BusinessFeeComparator["Between"] = "BETWEEN";
    BusinessFeeComparator["NotEquals"] = "NOT_EQUALS";
})(BusinessFeeComparator || (BusinessFeeComparator = {}));
//# sourceMappingURL=BusinessFee.js.map